module.exports = __webpack_public_path__ + "static/reloadmenu-94d4f7a94bab7973d70c29263f4a8012.png";